import React, { useState } from 'react'
import emailjs from '@emailjs/browser';
import emailTemplate from './emailTemplate';

export default function Qoute() {
  const [formStatus, setFormStatus] = useState('');
  const [sendingForm, setSendingForm] = useState(false);


  
  emailjs.init({
    publicKey: 'KvLCTJKtgGwsJaglg', 
    blockHeadless: true, 
  });

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission
    setSendingForm(true);
    const form = e.target; 
    const formData = {
      firstName: form.first_name.value,
      lastName: form.last_name.value,
      phone: form.phone.value,
      email: form.email.value,
      message: form.message.value,
      date: new Date().toDateString(),
    };

    const emailContent = emailTemplate(formData); 

    console.log(formData);
    emailjs.send(
      'service_a228tyj',
      'template_xk5c9y9',
      {
      firstName: formData.firstName,
      lastName: formData.lastName,
      phone: formData.phone,
      email: formData.email,
      date: formData.date,
      message: formData.message,
      })
      .then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          setFormStatus('Your message has been sent successfully!');
          form.reset(); 
          setSendingForm(false);
        },
        (error) => {
          console.log('FAILED...', error);
          setFormStatus('Failed to send your message. Please try again later.');
          setSendingForm(false);
        }
      );
  };
  return (
    <div id='Qoute' className='qoute description-grid'>
      <div className='text-white di'>
        <h3 className='mb-4 text-left' >Get a Free Quote.</h3>
      </div>
      <div className=' description-0'>
      <form id="quoteForm" onSubmit={handleSubmit}>
          <div className="form-group d-flex justify-content-between">
            <div className="col-6 ml-0 pl-0 pr-1">
              <input
                className=""
                type="text"
                name="first_name" // Match this to your EmailJS template variable
                placeholder="First Name"
                required
              />
            </div>
            <div className="col-6 mr-0 pr-0 pl-1">
              <input
                className=""
                type="text"
                name="last_name" // Match this to your EmailJS template variable
                placeholder="Last Name"
                required
              />
            </div>
          </div>
          <div className="form-group">
            <input
              type="text"
              name="phone" // Match this to your EmailJS template variable
              placeholder="Phone number"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              name="email" // Match this to your EmailJS template variable
              placeholder="Email"
              required
            />
          </div>
          <div className="form-group">
            <textarea
              name="message"
              placeholder="Message"
              required
            />
          </div>
          <div className="form-group text-end">
          <button 
              className="qoute-btn mt-3" 
              type="submit" 
              disabled={sendingForm} 
            >
              {sendingForm ? (
                <div className="spinner-border spinner-border-sm text-gray">
                  <span className="sr-only"></span>
                </div>
              ) : (
                <span>Send Form</span>
              )}
            </button>

          </div>
        </form>
        {formStatus && <p className='text-white text-center mt-5'>{formStatus}</p>}

      </div>
    </div>
  )
}
